module.exports = __webpack_public_path__ + "img/mobis-logo.73bbdb92.jpg";